import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'rosie-website-texting-banner',
  templateUrl: './website-texting-banner.component.html',
  styleUrls: ['./website-texting-banner.component.scss'],
  standalone: false,
})
export class WebsiteTextingBannerComponent {
  @Output() dismissed = new EventEmitter<void>();

  constructor(private router: Router) {}

  dismiss(): void {
    this.dismissed.emit();
  }

  navigate(): void {
    this.router.navigate(['/settings', { section: 'website-widgets' }]);
  }
}
